import React from 'react';
import {
  Typography,
  Box, Step, StepLabel, Stepper,
  Divider,
} from '@mui/material';
import QontoStepIcon from '../QontoStepIcon';
import { QontoVerticalConnector } from '../QontoStepIcon/components';
import { Currency } from '../../types/account';
import { parseAmountWithCurrency } from '../LoanRequestConditions/LoanInfoRow';

interface PlanDetailInfoProps {
  expirationDate: Date;
  installmentAmount: number;
  lastInstallmentAmount: number;
  periods: number;
  currency: Currency
}

export default function PlanDetailInfo(propsComponent: PlanDetailInfoProps) {
  const {
    expirationDate,
    installmentAmount,
    lastInstallmentAmount,
    periods,
    currency,
  } = propsComponent;

  const steps = Array.from({ length: periods }, (_, index) => {
    const date = new Date(expirationDate);
    date.setMonth(date.getMonth() + index);
    const amount = index === periods - 1 ? lastInstallmentAmount : installmentAmount;
    return {
      key: index,
      labelDate: (
        <Typography variant="body2" sx={{ fontWeight: index === 0 || index === periods - 1 ? 'bold' : 'normal' }} component="span">
          {date.toLocaleDateString('es-CL', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </Typography>
      ),
      labelAmount: (
        <Typography variant="body2" sx={{ fontWeight: index === 0 || index === periods - 1 ? 'bold' : 'normal' }} component="span">
          {parseAmountWithCurrency(
            currency,
            amount,
          )}
        </Typography>
      ),
    };
  });

  const optionalLabel = (key: number, loanPeriods: number) => {
    if (loanPeriods === 1) {
      return 'Cuota única';
    }
    if (key === 0) {
      return 'Primera cuota';
    }
    if (key === loanPeriods - 1) {
      return 'Última cuota';
    }
    return null;
  };

  return (
    <Box sx={{
      paddingInline: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      maxHeight: '65vh',
      minHeight: '100%',
    }}
    >
      <Box sx={{
        height: '30%',
      }}
      >
        <Typography variant="h6" textAlign="center">
          Flujo de pago
        </Typography>
        <br />
        <Typography variant="body2" textAlign="center" component="div">
          Revisa las fechas y montos de cada cuota.
        </Typography>
        <Divider sx={{ marginBlock: 3 }} />
      </Box>
      <Stepper
        activeStep={0}
        orientation="vertical"
        connector={<QontoVerticalConnector />}
        sx={{
          backgroundColor: 'background.defaultSecondary', borderRadius: 8, paddingInline: 4, paddingBlock: 6, width: '100%', height: '45%', overflowY: 'auto',
        }}
      >
        {steps.map((step) => (
          <Step key={step.key}>
            <StepLabel
            // eslint-disable-next-line react/no-unstable-nested-components
              StepIconComponent={(props) => (
              // eslint-disable-next-line react/jsx-props-no-spreading
                <QontoStepIcon {...props} variant="vertical" />
              )}
              optional={step.key === 0 || step.key === periods - 1 ? (
                <Typography variant="caption" component="span" fontStyle="italic">
                  {optionalLabel(step.key, periods)}
                </Typography>
              ) : null}
              sx={{ padding: 0 }}
            >
              <div
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                {step.labelDate}
                {step.labelAmount}
              </div>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <Box sx={{
        height: '25%',
      }}
      >
        <Divider sx={{ marginBlock: 3 }} />
        <Box sx={{
          width: '100%',
          display: 'flex',
          backgroundColor: 'background.defaultSecondary',
          borderRadius: 4,
          paddingInline: 8,
          paddingBlock: 3,
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
        >
          <Typography variant="caption" component="span">
            Estas fechas de cobro son aproximadas
            ya que el cobro vía PAC puede demorar hasta 2 días hábiles.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
